import React from "react";
import {Container} from "react-bootstrap";
import moment from "moment";
import 'moment-timezone';
import Table from "react-bootstrap/Table";

import JwtClient from "./JwtClient";
import Logout from "./utils";
import Alert from "./Alert";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UPSMIEventForm from "./UPSMIEventForm";

class TrackingNumberForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            update: false,
            packageID: props.packageID,
            tracking_number: props.tracking_number,
            isSubmitting: false,
            submitErr: '',
        };
    }

    render() {
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <div className="form-row">
                            <div className="col-6">
                                <input
                                    className={this.state.submitErr ? "form-control is-invalid" : "form-control"}
                                    disabled={!this.state.update}
                                    value={this.state.tracking_number}
                                    onChange={e => {
                                        const v = e.currentTarget.value;
                                        this.setState({tracking_number: v.toUpperCase()});
                                    }}
                                />
                                <div className="invalid-feedback" data-testid="order-err">{this.state.submitErr}</div>
                            </div>
                            <div className="col-2">
                                <button type="submit" className="btn btn-primary"
                                        disabled={this.state.isSubmitting}
                                    //     disabled={true}  // changing track might cause a lot of problems in future (db integrity errors)
                                >{this.state.update ? 'Update' : 'Edit'}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (!this.state.update) {
            this.setState({update: true})
            return
        }

        this.setState({isSubmitting: true, submitErr: '', update: false});
        fetch("/api/v1/admin/packages/" + this.state.packageID + "/relabel", {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            },
            body: JSON.stringify({
                'tracking_number': this.state.tracking_number,
            })
        })
            .then(response => {
                this.setState({isSubmitting: false});

                if (response.status === 200) {
                    this.setState({isSubmitting: false});
                    window.location.href = '/packages/' + this.state.tracking_number;
                } else if (response.status === 400) {
                    response.json().then(data => {
                        this.setState({isSubmitting: false, submitErr: 'bad request'});
                    })
                } else if (response.status === 401) {
                    this.setState({isSubmitting: false, submitErr: 'unauthorized'})
                } else {
                    this.setState({isSubmitting: false, submitErr: 'server error'})
                }
            })
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.tracking_number !== this.props.tracking_number && prevProps.packageID !== this.props.packageID) {
            this.setState({tracking_number: this.props.tracking_number, packageID: this.props.packageID})
        }
    }
}

function TrackingEvents(props) {
    return (
        <div>
            <h5 className="mt-4">Events</h5>
            <Table>
                <thead>
                <tr>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Address</th>
                    <th>Date</th>
                    <th title="Timezone: New York (America/New_York)">Gathered</th>
                </tr>
                </thead>
                <tbody>
                {
                    props.trackingEvents.map((e, index) => {
                        return (
                            <tr key={index}>
                                <td>{e.code}</td>
                                <td>{e.description}</td>
                                <td>{e.city} {e.state} {e.zip}</td>
                                <td>{e.date}</td>
                                <td>{moment(e.created_at).tz('America/New_York').format('M/D/YY h:mm a')}</td>
                            </tr>
                        );
                    })
                }
                </tbody>
            </Table>
        </div>
    )
}

const money = cents => (cents === null || cents === undefined) ? '—' : '$' + (cents / 100).toFixed(2);

const STATUS_BADGE = {
    selected: 'success',
    rated: 'secondary',
    ineligible: 'warning',
    error: 'danger',
    unrated: 'light',
};

function priceSource(s) {
    const rc = s.rate_calc;
    if (rc && rc.source === 'velox_rate_card') {
        return `Velox rate card ${rc.rate_card}, zone ${rc.zone}`;
    }
    if (rc && rc.old_card) {
        return `GOFO API ${money(rc.api_cents)} + rate cards ${rc.old_card} / ${rc.new_card}`;
    }
    if (s.status === 'unrated') {
        return 'not rated (only carrier)';
    }
    if (s.carrier_amount_cents === null || s.carrier_amount_cents === undefined) {
        return '—';
    }
    return `${s.carrier} rate API`;
}

function ChargesTable({charges, carrierTotal, clientTotal}) {
    return (
        <Table size="sm" className="mb-2">
            <thead>
            <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Kind</th>
                <th>Carrier</th>
                <th>Basis</th>
                <th>Markup</th>
                <th>Client</th>
            </tr>
            </thead>
            <tbody>
            {charges.map((c, i) => (
                <tr key={i}>
                    <td>{c.code}</td>
                    <td>{c.name}</td>
                    <td>{c.kind}</td>
                    <td>{money(c.carrier_cents)}</td>
                    <td>{c.basis_cents ? money(c.basis_cents) : ''}</td>
                    <td>{c.markup_pct ? c.markup_pct + '%' : ''}</td>
                    <td>{money(c.client_cents)}</td>
                </tr>
            ))}
            <tr className="font-weight-bold">
                <td colSpan="3">Total</td>
                <td>{money(carrierTotal)}</td>
                <td/>
                <td/>
                <td>{money(clientTotal)}</td>
            </tr>
            </tbody>
        </Table>
    );
}

function RateCalc({rateCalc}) {
    return (
        <dl className="row small mb-2">
            {Object.keys(rateCalc).map(k => [
                <dt key={k + 't'} className="col-sm-3">{k}</dt>,
                <dd key={k + 'd'} className="col-sm-9">{typeof rateCalc[k] === 'object' ? JSON.stringify(rateCalc[k]) : String(rateCalc[k])}</dd>,
            ])}
        </dl>
    );
}

class CarrierSelectionBlock extends React.Component {
    state = {open: false, details: {}};

    toggleDetails = i => {
        this.setState(prev => ({details: {...prev.details, [i]: !prev.details[i]}}));
    };

    render() {
        const rows = this.props.rows;
        const winner = rows.find(r => r.status === 'selected');
        const title = winner ?
            `Carrier selection — winner: ${winner.carrier} ${winner.mail_class}, ${money(winner.client_amount_cents)}` :
            'Carrier selection';
        return (
            <div className="mt-4">
                <Button variant="outline-secondary" size="sm"
                        onClick={() => this.setState({open: !this.state.open})}>
                    {this.state.open ? '▾ ' : '▸ '}{title}
                </Button>
                {this.state.open && (
                    <div className="mt-3">
                        <p className="small text-muted">
                            Requested {moment(rows[0].created_at).tz('America/New_York').format('M/D/YY h:mm a')},
                            reference {rows[0].trace_id}. <a href="/carrier-selection">How the carrier is selected</a>
                        </p>
                        <Table size="sm">
                            <thead>
                            <tr>
                                <th>Rank</th>
                                <th>Carrier</th>
                                <th>Status</th>
                                <th>Price source</th>
                                <th>Carrier</th>
                                <th>Markup</th>
                                <th>Client</th>
                                <th>Why</th>
                            </tr>
                            </thead>
                            <tbody>
                            {rows.map((s, i) => {
                                const hasDetails = (s.charges && s.charges.length > 0) || !!s.rate_calc;
                                const rowEls = [
                                    <tr key={i} className={s.status === 'selected' ? 'table-success' : ''}>
                                        <td>{s.price_rank || ''}</td>
                                        <td>{s.carrier} {s.mail_class}</td>
                                        <td><span className={'badge badge-' + (STATUS_BADGE[s.status] || 'light')}>{s.status}</span></td>
                                        <td>{priceSource(s)}</td>
                                        <td>{money(s.carrier_amount_cents)}</td>
                                        <td>{s.markup_pct ? s.markup_pct + '%' : ''}</td>
                                        <td>{money(s.client_amount_cents)}</td>
                                        <td>
                                            {s.reasons && s.reasons.length > 0 && <code>{s.reasons.join(', ')}</code>}
                                            {s.description && <div className="small">{s.description}</div>}
                                            {hasDetails &&
                                                <button className="btn btn-link btn-sm p-0"
                                                        onClick={() => this.toggleDetails(i)}>
                                                    {this.state.details[i] ? 'hide price' : 'show price'}
                                                </button>}
                                        </td>
                                    </tr>
                                ];
                                if (hasDetails && this.state.details[i]) {
                                    rowEls.push(
                                        <tr key={i + 'd'}>
                                            <td/>
                                            <td colSpan="7">
                                                {s.charges && s.charges.length > 0 &&
                                                    <ChargesTable charges={s.charges}
                                                                  carrierTotal={s.carrier_amount_cents}
                                                                  clientTotal={s.client_amount_cents}/>}
                                                {s.rate_calc && <RateCalc rateCalc={s.rate_calc}/>}
                                            </td>
                                        </tr>
                                    );
                                }
                                return rowEls;
                            })}
                            </tbody>
                        </Table>
                    </div>
                )}
            </div>
        );
    }
}

function DT({children}) {
    return <dt className="col-sm-3">{children}</dt>;
}

function DD({children}) {
    return <dd className="col-sm-9">{children}</dd>;
}


export default class Package extends React.Component {
    state = {
        alert: '',
        package: {},
        events: [],
        selection: [],
    };

    render() {
        if (!!this.state.alert) {
            return <Alert>{this.state.alert}</Alert>
        }

        const p = this.state.package;
        const events = this.state.events;
        const selection = this.state.selection;
        if (!p.customs_hawb) {
            return null
        }

        const consigneeAddress = `${p.ship_to_street} ${p.ship_to_city}, ${p.ship_to_state} ${p.ship_to_zip}`
        return (
            <Container>
                <h4 className="mt-4">HAWB: {p.customs_hawb}
                    {
                        !!p.deleted_at ?
                            <span className="text-danger float-right">DELETED</span> :
                            null
                    }
                </h4>
                <Row>
                    <Col md="2" className="my-2 pr-0">
                        <Button onClick={this.showLabel} className="btn-block"
                                disabled={p.empty_label_content_flag}>Label</Button>
                    </Col>
                    <Col md="2" className="my-2 pr-0">
                        <a className="btn btn-success btn-block"
                           href={
                               p.carrier === 'VIPPARCEL' ?
                                   "https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=" + p.tracking_number :
                                   "https://parcelsapp.com/en/tracking/" + p.tracking_number
                           }
                           target="_blank" rel="noopener noreferrer">Track</a>
                    </Col>
                    <Col md="2" className="my-2 pr-0">
                        <a className="btn btn-warning btn-block"
                           href={'https://www.google.com/maps/place/' + consigneeAddress} target="_blank"
                           rel="noopener noreferrer">Maps</a>
                    </Col>
                    {
                        !!p.has_canadian_invoice &&
                        <Col md="2" className="my-2 pr-0">
                            <Button onClick={this.showInvoice} className="btn-block"
                            >Invoice</Button>
                        </Col>
                    }
                </Row>
                <dl className="row">
                    <DT>User</DT>
                    <DD><strong>{p.user_id}</strong></DD>
                    <DT>Track</DT>
                    {/*<DD>{p.tracking_number}</DD>*/}
                    <DD><TrackingNumberForm tracking_number={p.tracking_number} packageID={p.id}/></DD>
                    <DT>Aux track</DT>
                    <DD>{p.auxiliary_tracking_number}</DD>
                    <DT>{!!p.manifest_mawb && 'MAWB'}</DT>
                    <DD>{!!p.manifest_mawb && <a href={"/manifests/" + p.manifest_id}>{p.manifest_mawb}</a>}</DD>
                    <DT>Description</DT>
                    <DD>{p.customs_description}</DD>
                    <DT>{!!p.customs_items && p.customs_items.length > 0 && 'Items'}</DT>
                    <DD>{(_ => {
                        if (p.customs_items && p.customs_items.length > 0) {
                            return (
                                <ul>
                                    {p.customs_items.map((v, i) => {
                                        return <li key={i}>{v.description}</li>
                                    })}
                                </ul>
                            )
                        }
                        return null;
                    })()}
                    </DD>
                    <DT>Dimensions</DT>
                    <DD>{p.dimensions_width_mm}x{p.dimensions_length_mm}x{p.dimensions_height_mm} (mm)
                        | {(p.dimensions_width_mm / 25.4).toFixed(2)}x{(p.dimensions_length_mm / 25.4).toFixed(2)}x{(p.dimensions_height_mm / 25.4).toFixed(2)} (in)</DD>
                    <DT>Weight</DT>
                    <DD>{p.dimensions_weight_g} (g) | {(p.dimensions_weight_g / 453.592).toFixed(2)} (lbs)</DD>
                    <DT>Declared</DT>
                    <DD>{(p.customs_declared_value_cents / 100).toString()}$</DD>
                    <DT>Delivery</DT>
                    <DD>{p.carrier_delivery_cents / 100}$</DD>
                    <DT>Created</DT>
                    <DD>{moment(p.created_at).tz('America/New_York').format('MMMM Do YYYY h:mm a')}</DD>
                    <DT>Ship to</DT>
                    <DD>{p.ship_to_person_name}<br/>{consigneeAddress}</DD>
                    <DT><span title="Timezone: New York (America/New_York)">Last Event Gathered</span></DT>
                    <DD><span>{moment(p.last_tracking_event_updated_at).tz('America/New_York').format('MMMM Do YYYY h:mm a')}</span>
                        {!p.manifest_mawb && (
                            p.track_if_unmanifested ?
                                <small className="text-muted ml-3">Force Tracking</small> :
                                <button onClick={this.forceTracking} className="btn btn-outline-secondary ml-3">Force
                                    Tracking</button>
                        )}
                    </DD>
                </dl>

                {!!selection && selection.length > 0 && <CarrierSelectionBlock rows={selection}/>}


                {!!events && events.length > 0 && events[0].description !== "Delivered" &&
                    (p.mail_class === 'ExpeditedMailInnovations' || p.mail_class === 'PriorityMailInnovations') &&
                    <UPSMIEventForm packageID={p.id} addEvent={this.addEvent} trackingNumber={p.tracking_number}/>}

                {!!events && events.length > 0 && <TrackingEvents trackingEvents={events}/>}

            </Container>
        );
    }

    forceTracking = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch("/api/v1/admin/track-if-unmanifested?package_id=" + this.state.package.id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                },
            });

            if (response.status === 200) {
                this.setState(prevState => ({
                    package: prevState.package ? {
                        ...prevState.package,
                        track_if_unmanifested: true
                    } : {} // Prevents null state
                }));
            } else {
                this.setState({alert: 'server error'});
            }
        } catch (error) {
            this.setState({alert: 'network error'});
        }
    };

    componentDidMount() {
        this.getPackage(this.props.match.params.trackingNumberOrHawb);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params.trackingNumberOrHawb !== this.props.match.params.trackingNumberOrHawb) {
            this.setState({alert: ''});
            this.getPackage(this.props.match.params.trackingNumberOrHawb);
        }
    }

    getPackage = (trackingNumberOrHawb) => {
        JwtClient.get('/api/v1/admin/search-package?q=' + trackingNumberOrHawb)
            .then(response => {
                const d = response.data;
                this.setState({
                    package: d.package,
                    events: d.tracking_events,
                    selection: d.carrier_selection || [],
                });
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        Logout();
                    } else if (error.response.status === 404) {
                        this.setState({alert: 'Package with tracking number or hawb ' + trackingNumberOrHawb + ' is not found'});
                    } else {
                        this.setState({alert: 'Error on fetching package, status: ' + error.response.status});
                    }
                } else {
                    this.setState({alert: JSON.stringify(error)});
                }
            })
    };

    showLabel = () => {
        JwtClient.get(`/api/v1/admin/packages/${this.state.package.tracking_number}/label`)
            .then(response => {
                if (response.status === 200) {
                    this.openBase64InNewTab(response.data.pdf_base64)
                }
            })
    };

    showInvoice = () => {
        JwtClient.get(`/api/v1/admin/packages/${this.state.package.tracking_number}/canadian-invoice`)
            .then(response => {
                if (response.status === 200) {
                    this.openBase64InNewTab(response.data.pdf_base64)
                }
            })
    };

    openBase64InNewTab = (data) => {
        data = 'data:application/pdf;base64,' + data;
        let w = window.open('about:blank');
        setTimeout(function () {
            w.document.write("<iframe width='100%' height='100%' src=" + data + '>');
        }, 0);
    }

    addEvent = (event) => {
        this.setState((prevState) => ({events: [event, ...prevState.events]}));
    };
}
